module.exports = __webpack_public_path__ + "static/media/bq.2317a3ae.svg";